import { Colors, IcDevice, IcMediaLibrary, Text } from 'basic-ui-lib';
import styled from 'styled-components';
import useGetScreensInStore from 'modules/store/services/hooks/useListScreensInStore';
import { useParams } from 'react-router-dom';
import StoreDevices from './StoreDevices';
import StorePlaylists from './StorePlaylists';
import useGetPlaylistsInStore from 'modules/store/services/hooks/useGetPlaylistsInStore';
import { useState } from 'react';
import { Segmented } from 'antd';

const StoreResources = () => {
  const { id } = useParams<{ id: string }>();
  const { screensListInStore } = useGetScreensInStore(id || '');
  const { playlistsInStore } = useGetPlaylistsInStore(id || '');
  const [type, setType] = useState<string>('devices');

  return (
    <Container>
      <Segmented
        options={[
          {
            label: (
              <>
                <IcDevice
                  width={20}
                  height={20}
                  fill={type === 'devices' ? Colors.primary[6] : Colors.neutral.text[6]}
                />
                <Text content_2 semibold color={type === 'devices' ? 'primary.6' : 'neutral.text.6'}>
                  Devices ({screensListInStore?.content.length || 0})
                </Text>
              </>
            ),
            value: 'devices',
          },
          {
            label: (
              <>
                <IcMediaLibrary
                  width={20}
                  height={20}
                  fill={type === 'playlists' ? Colors.primary[6] : Colors.neutral.text[6]}
                />
                <Text content_2 semibold color={type === 'playlists' ? 'primary.6' : 'neutral.text.6'}>
                  Playlists ({playlistsInStore?.content.length || 0})
                </Text>
              </>
            ),
            value: 'playlists',
          },
        ]}
        defaultValue='devices'
        onChange={setType}
      />
      {type === 'devices' && <StoreDevices devices={screensListInStore?.content || []} />}
      {type === 'playlists' && <StorePlaylists playlists={playlistsInStore?.content || []} />}
    </Container>
  );
};

export default StoreResources;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  background-color: ${Colors.neutral.bg[2]};
  padding: 16px;
  gap: 8px;

  .ant-tabs-tab {
    padding: 9px 16px;
  }

  .ant-segmented-group {
    > label {
      flex: 1;
      padding: 10px 0;
    }

    .ant-segmented-item-label {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 8px;
    }
  }
`;
